import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgIconSpeaker = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2.5 8.26433C2.5 6.59862 3.85033 5.24829 5.51604 5.24829H5.911V14.7991H5.51604C3.85033 14.7991 2.5 13.4488 2.5 11.783V8.26433Z",
			fill: "#333333"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.92265 5.03605C6.78508 5.17147 6.70703 5.36063 6.70703 5.55862V14.4888C6.70703 14.6868 6.78508 14.8759 6.92265 15.0113L9.90523 17.9473C10.1873 18.225 10.5673 18.3806 10.9631 18.3806H12.6194C13.2474 18.3806 13.7564 17.8461 13.7564 17.1868V2.8606C13.7564 2.20125 13.2474 1.66675 12.6194 1.66675H10.9631C10.5673 1.66675 10.1873 1.82239 9.90522 2.10007L6.92265 5.03605Z",
			fill: "#333333"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.856 5.42313C16.078 5.19001 16.4379 5.19001 16.6599 5.42313C18.8914 7.76614 18.8914 11.5649 16.6599 13.9079C16.4379 14.1411 16.078 14.1411 15.856 13.9079C15.6339 13.6748 15.6339 13.2969 15.856 13.0638C17.6434 11.187 17.6434 8.14409 15.856 6.26731C15.6339 6.03419 15.6339 5.65624 15.856 5.42313Z",
			fill: "#333333",
			stroke: "#333333",
			strokeWidth: .5,
			strokeLinecap: "round"
		})
	]
});
export default SvgIconSpeaker;
